/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './content-page-edit.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/di/injector';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/change_detection';
import * as import8 from '../shared/config.service';
import * as import9 from '../shared/intl.service';
import * as import10 from '../shared/meta.service';
import * as import11 from '../shared/utils.service';
import * as import12 from '@angular/forms/src/form_builder';
import * as import13 from '@angular/router/src/router';
import * as import14 from '../shared/content.service';
import * as import15 from '@angular/router/src/router_state';
import * as import16 from '@angular/core/src/metadata/view';
import * as import17 from '@angular/core/src/linker/component_factory';
import * as import18 from '../../../node_modules/@angular/common/src/directives/ng_switch.ngfactory';
import * as import19 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import20 from '@angular/common/src/pipes/date_pipe';
import * as import21 from '@angular/common/src/pipes/uppercase_pipe';
import * as import22 from '@angular/core/src/linker/template_ref';
import * as import23 from '@angular/core/src/i18n/tokens';
import * as import24 from '@angular/common/src/directives/ng_switch';
import * as import25 from '@angular/common/src/directives/ng_if';
import * as import26 from '../../../node_modules/@angular/forms/src/directives/reactive_directives/form_group_directive.ngfactory';
import * as import27 from '../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import28 from '../../../node_modules/@angular/forms/src/directives/checkbox_value_accessor.ngfactory';
import * as import29 from '../../../node_modules/@angular/forms/src/directives/reactive_directives/form_control_name.ngfactory';
import * as import30 from '../../../node_modules/@angular/forms/src/directives/default_value_accessor.ngfactory';
import * as import31 from '../../../node_modules/@angular/forms/src/directives/reactive_directives/form_group_name.ngfactory';
import * as import32 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import33 from '@angular/core/src/linker/element_ref';
import * as import34 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import35 from '@angular/forms/src/directives/checkbox_value_accessor';
import * as import36 from '@angular/forms/src/directives/control_value_accessor';
import * as import37 from '@angular/forms/src/directives/reactive_directives/form_control_name';
import * as import38 from '@angular/forms/src/directives/ng_control';
import * as import39 from '@angular/forms/src/directives/ng_control_status';
import * as import40 from '@angular/forms/src/directives/default_value_accessor';
import * as import41 from '@angular/common/src/directives/ng_for';
import * as import42 from '@angular/forms/src/directives/reactive_directives/form_group_name';
import * as import43 from '@angular/forms/src/directives/control_container';
import * as import44 from '@angular/forms/src/directives/reactive_directives/form_group_directive';
import * as import45 from './html-editor.component.ngfactory';
import * as import46 from './html-editor.component';
export class Wrapper_ContentPageEditComponent {
  context:import0.ContentPageEditComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any) {
    this.changed = false;
    this.context = new import0.ContentPageEditComponent(p0,p1,p2,p3,p4,p5,p6,p7);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_ContentPageEditComponent_Host:import2.RenderComponentType = (null as any);
class _View_ContentPageEditComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _ContentPageEditComponent_0_4:Wrapper_ContentPageEditComponent;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPageEditComponent_Host0,renderType_ContentPageEditComponent_Host,import6.ViewType.HOST,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer,'ng-component',import4.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_ContentPageEditComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._ContentPageEditComponent_0_4 = new Wrapper_ContentPageEditComponent(this.parentInjector.get(import8.ConfigService),this.parentInjector.get(import9.IntlService),this.parentInjector.get(import10.MetaService),this.parentInjector.get(import11.UtilsService),this.parentInjector.get(import12.FormBuilder),this.parentInjector.get(import13.Router),this.parentInjector.get(import14.ContentService),this.parentInjector.get(import15.ActivatedRoute));
    this._appEl_0.initComponent(this._ContentPageEditComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._ContentPageEditComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.ContentPageEditComponent) && (0 === requestNodeIndex))) { return this._ContentPageEditComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ContentPageEditComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._ContentPageEditComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentPageEditComponent_Host0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_ContentPageEditComponent_Host === (null as any))) { (renderType_ContentPageEditComponent_Host = viewUtils.createRenderComponentType('',0,import16.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_ContentPageEditComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const ContentPageEditComponentNgFactory:import17.ComponentFactory<import0.ContentPageEditComponent> = new import17.ComponentFactory<import0.ContentPageEditComponent>('ng-component',viewFactory_ContentPageEditComponent_Host0,import0.ContentPageEditComponent);
const styles_ContentPageEditComponent:any[] = ([] as any[]);
var renderType_ContentPageEditComponent:import2.RenderComponentType = (null as any);
class _View_ContentPageEditComponent0 extends import1.AppView<import0.ContentPageEditComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _NgSwitch_2_3:import18.Wrapper_NgSwitch;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _appEl_5:import3.AppElement;
  _TemplateRef_5_5:any;
  _NgSwitchCase_5_6:import18.Wrapper_NgSwitchCase;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _appEl_7:import3.AppElement;
  _TemplateRef_7_5:any;
  _NgSwitchCase_7_6:import18.Wrapper_NgSwitchCase;
  _text_8:any;
  _anchor_9:any;
  /*private*/ _appEl_9:import3.AppElement;
  _TemplateRef_9_5:any;
  _NgSwitchCase_9_6:import18.Wrapper_NgSwitchCase;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _anchor_23:any;
  /*private*/ _appEl_23:import3.AppElement;
  _TemplateRef_23_5:any;
  _NgIf_23_6:import19.Wrapper_NgIf;
  _text_24:any;
  _text_25:any;
  _text_26:any;
  _text_27:any;
  _text_28:any;
  _text_29:any;
  _pipe_date_0:import20.DatePipe;
  _pipe_uppercase_1:import21.UpperCasePipe;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPageEditComponent0,renderType_ContentPageEditComponent,import6.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','content-header'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n  ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'h1',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._NgSwitch_2_3 = new import18.Wrapper_NgSwitch();
    this._text_3 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_4 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._appEl_5 = new import3.AppElement(5,2,this,this._anchor_5);
    this._TemplateRef_5_5 = new import22.TemplateRef_(this._appEl_5,viewFactory_ContentPageEditComponent1);
    this._NgSwitchCase_5_6 = new import18.Wrapper_NgSwitchCase(this._appEl_5.vcRef,this._TemplateRef_5_5,this._NgSwitch_2_3.context);
    this._text_6 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._appEl_7 = new import3.AppElement(7,2,this,this._anchor_7);
    this._TemplateRef_7_5 = new import22.TemplateRef_(this._appEl_7,viewFactory_ContentPageEditComponent2);
    this._NgSwitchCase_7_6 = new import18.Wrapper_NgSwitchCase(this._appEl_7.vcRef,this._TemplateRef_7_5,this._NgSwitch_2_3.context);
    this._text_8 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._anchor_9 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._appEl_9 = new import3.AppElement(9,2,this,this._anchor_9);
    this._TemplateRef_9_5 = new import22.TemplateRef_(this._appEl_9,viewFactory_ContentPageEditComponent3);
    this._NgSwitchCase_9_6 = new import18.Wrapper_NgSwitchCase(this._appEl_9.vcRef,this._TemplateRef_9_5,this._NgSwitch_2_3.context);
    this._text_10 = this.renderer.createText(this._el_2,'\n  ',(null as any));
    this._text_11 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_12 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_13 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','content'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n  ',(null as any));
    this._el_15 = import4.createRenderElement(this.renderer,this._el_13,'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n    ',(null as any));
    this._el_17 = import4.createRenderElement(this.renderer,this._el_15,'div',new import4.InlineArray2(2,'class','col-xs-12'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n      ',(null as any));
    this._el_19 = import4.createRenderElement(this.renderer,this._el_17,'div',new import4.InlineArray2(2,'class','box'),(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'\n        ',(null as any));
    this._el_21 = import4.createRenderElement(this.renderer,this._el_19,'div',new import4.InlineArray2(2,'class','box-body'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n\n          ',(null as any));
    this._anchor_23 = this.renderer.createTemplateAnchor(this._el_21,(null as any));
    this._appEl_23 = new import3.AppElement(23,21,this,this._anchor_23);
    this._TemplateRef_23_5 = new import22.TemplateRef_(this._appEl_23,viewFactory_ContentPageEditComponent4);
    this._NgIf_23_6 = new import19.Wrapper_NgIf(this._appEl_23.vcRef,this._TemplateRef_23_5);
    this._text_24 = this.renderer.createText(this._el_21,'\n\n\n        ',(null as any));
    this._text_25 = this.renderer.createText(this._el_19,'\n        ',(null as any));
    this._text_26 = this.renderer.createText(this._el_19,'\n      ',(null as any));
    this._text_27 = this.renderer.createText(this._el_17,'\n    ',(null as any));
    this._text_28 = this.renderer.createText(this._el_15,'\n  ',(null as any));
    this._text_29 = this.renderer.createText(this._el_13,'\n',(null as any));
    this._pipe_date_0 = new import20.DatePipe(this.parentInjector.get(import23.LOCALE_ID));
    this._pipe_uppercase_1 = new import21.UpperCasePipe();
    this.init(([] as any[]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._anchor_7,
      this._text_8,
      this._anchor_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._anchor_23,
      this._text_24,
      this._text_25,
      this._text_26,
      this._text_27,
      this._text_28,
      this._text_29
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import24.NgSwitchCase) && (5 === requestNodeIndex))) { return this._NgSwitchCase_5_6.context; }
    if (((token === import22.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import24.NgSwitchCase) && (7 === requestNodeIndex))) { return this._NgSwitchCase_7_6.context; }
    if (((token === import22.TemplateRef) && (9 === requestNodeIndex))) { return this._TemplateRef_9_5; }
    if (((token === import24.NgSwitchCase) && (9 === requestNodeIndex))) { return this._NgSwitchCase_9_6.context; }
    if (((token === import24.NgSwitch) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._NgSwitch_2_3.context; }
    if (((token === import22.TemplateRef) && (23 === requestNodeIndex))) { return this._TemplateRef_23_5; }
    if (((token === import25.NgIf) && (23 === requestNodeIndex))) { return this._NgIf_23_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.context.action;
    this._NgSwitch_2_3.check_ngSwitch(currVal_2_0_0,throwOnChange,false);
    this._NgSwitch_2_3.detectChangesInInputProps(this,this._el_2,throwOnChange);
    const currVal_5_0_0:any = 'add';
    this._NgSwitchCase_5_6.check_ngSwitchCase(currVal_5_0_0,throwOnChange,false);
    this._NgSwitchCase_5_6.detectChangesInInputProps(this,this._anchor_5,throwOnChange);
    const currVal_7_0_0:any = 'update';
    this._NgSwitchCase_7_6.check_ngSwitchCase(currVal_7_0_0,throwOnChange,false);
    this._NgSwitchCase_7_6.detectChangesInInputProps(this,this._anchor_7,throwOnChange);
    const currVal_9_0_0:any = 'update';
    this._NgSwitchCase_9_6.check_ngSwitchCase(currVal_9_0_0,throwOnChange,false);
    this._NgSwitchCase_9_6.detectChangesInInputProps(this,this._anchor_9,throwOnChange);
    const currVal_23_0_0:any = (this.context.content || (this.context.action == 'add'));
    this._NgIf_23_6.check_ngIf(currVal_23_0_0,throwOnChange,false);
    this._NgIf_23_6.detectChangesInInputProps(this,this._anchor_23,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgSwitch_2_3.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_ContentPageEditComponent0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<import0.ContentPageEditComponent> {
  if ((renderType_ContentPageEditComponent === (null as any))) { (renderType_ContentPageEditComponent = viewUtils.createRenderComponentType('',0,import16.ViewEncapsulation.None,styles_ContentPageEditComponent,{})); }
  return new _View_ContentPageEditComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_ContentPageEditComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPageEditComponent1,renderType_ContentPageEditComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'span',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'Nouvelle page',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
}
function viewFactory_ContentPageEditComponent1(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentPageEditComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_ContentPageEditComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPageEditComponent2,renderType_ContentPageEditComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'span',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'Edition',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
}
function viewFactory_ContentPageEditComponent2(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentPageEditComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_ContentPageEditComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  /*private*/ _expr_4:any;
  _pipe_date_0_0:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPageEditComponent3,renderType_ContentPageEditComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_4 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'span',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,' ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'small',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._pipe_date_0_0 = import4.pureProxy2((<_View_ContentPageEditComponent0>this.parent)._pipe_date_0.transform.bind((<_View_ContentPageEditComponent0>this.parent)._pipe_date_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_4:any = import4.interpolate(1,'(modifié: ',valUnwrapper.unwrap(import4.castByValue(this._pipe_date_0_0,(<_View_ContentPageEditComponent0>this.parent)._pipe_date_0.transform)(((this.parent.context.content == (null as any))? (null as any): this.parent.context.content.update_date),'dd MM yyyy')),')');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_3,currVal_4);
      this._expr_4 = currVal_4;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentPageEditComponent3(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentPageEditComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_ContentPageEditComponent4 extends import1.AppView<any> {
  _el_0:any;
  _FormGroupDirective_0_3:import26.Wrapper_FormGroupDirective;
  _ControlContainer_0_4:any;
  _NgControlStatusGroup_0_5:import27.Wrapper_NgControlStatusGroup;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  _CheckboxControlValueAccessor_13_3:import28.Wrapper_CheckboxControlValueAccessor;
  _NG_VALUE_ACCESSOR_13_4:any[];
  _FormControlName_13_5:import29.Wrapper_FormControlName;
  _NgControl_13_6:any;
  _NgControlStatus_13_7:import27.Wrapper_NgControlStatus;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _DefaultValueAccessor_23_3:import30.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_23_4:any[];
  _FormControlName_23_5:import29.Wrapper_FormControlName;
  _NgControl_23_6:any;
  _NgControlStatus_23_7:import27.Wrapper_NgControlStatus;
  _text_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _el_29:any;
  _text_30:any;
  _text_31:any;
  _el_32:any;
  _DefaultValueAccessor_32_3:import30.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_32_4:any[];
  _FormControlName_32_5:import29.Wrapper_FormControlName;
  _NgControl_32_6:any;
  _NgControlStatus_32_7:import27.Wrapper_NgControlStatus;
  _text_33:any;
  _text_34:any;
  _el_35:any;
  _text_36:any;
  _el_37:any;
  _el_38:any;
  _text_39:any;
  _el_40:any;
  _DefaultValueAccessor_40_3:import30.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_40_4:any[];
  _FormControlName_40_5:import29.Wrapper_FormControlName;
  _NgControl_40_6:any;
  _NgControlStatus_40_7:import27.Wrapper_NgControlStatus;
  _text_41:any;
  _text_42:any;
  _text_43:any;
  _text_44:any;
  _el_45:any;
  _text_46:any;
  _text_47:any;
  _el_48:any;
  _text_49:any;
  _el_50:any;
  _FormGroupName_50_3:import31.Wrapper_FormGroupName;
  _ControlContainer_50_4:any;
  _NgControlStatusGroup_50_5:import27.Wrapper_NgControlStatusGroup;
  _text_51:any;
  _anchor_52:any;
  /*private*/ _appEl_52:import3.AppElement;
  _TemplateRef_52_5:any;
  _NgFor_52_6:import32.Wrapper_NgFor;
  _text_53:any;
  _text_54:any;
  _text_55:any;
  _text_56:any;
  _el_57:any;
  _text_58:any;
  _text_59:any;
  _el_60:any;
  _text_61:any;
  _el_62:any;
  _FormGroupName_62_3:import31.Wrapper_FormGroupName;
  _ControlContainer_62_4:any;
  _NgControlStatusGroup_62_5:import27.Wrapper_NgControlStatusGroup;
  _text_63:any;
  _anchor_64:any;
  /*private*/ _appEl_64:import3.AppElement;
  _TemplateRef_64_5:any;
  _NgFor_64_6:import32.Wrapper_NgFor;
  _text_65:any;
  _text_66:any;
  _text_67:any;
  _el_68:any;
  _text_69:any;
  _text_70:any;
  _el_71:any;
  _text_72:any;
  _el_73:any;
  _FormGroupName_73_3:import31.Wrapper_FormGroupName;
  _ControlContainer_73_4:any;
  _NgControlStatusGroup_73_5:import27.Wrapper_NgControlStatusGroup;
  _text_74:any;
  _anchor_75:any;
  /*private*/ _appEl_75:import3.AppElement;
  _TemplateRef_75_5:any;
  _NgFor_75_6:import32.Wrapper_NgFor;
  _text_76:any;
  _text_77:any;
  _text_78:any;
  _el_79:any;
  _text_80:any;
  _text_81:any;
  _el_82:any;
  _FormArrayName_82_3:import31.Wrapper_FormArrayName;
  _ControlContainer_82_4:any;
  _NgControlStatusGroup_82_5:import27.Wrapper_NgControlStatusGroup;
  _text_83:any;
  _el_84:any;
  _text_85:any;
  _anchor_86:any;
  /*private*/ _appEl_86:import3.AppElement;
  _TemplateRef_86_5:any;
  _NgFor_86_6:import32.Wrapper_NgFor;
  _text_87:any;
  _el_88:any;
  _text_89:any;
  _text_90:any;
  _text_91:any;
  _text_92:any;
  _el_93:any;
  _text_94:any;
  _text_95:any;
  _text_96:any;
  /*private*/ _expr_144:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPageEditComponent4,renderType_ContentPageEditComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_144 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'form',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._FormGroupDirective_0_3 = new import26.Wrapper_FormGroupDirective((null as any),(null as any));
    this._ControlContainer_0_4 = this._FormGroupDirective_0_3.context;
    this._NgControlStatusGroup_0_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
    this._text_1 = this.renderer.createText(this._el_0,'\n\n            ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','panel panel-default'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'Métadonnées',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n              ',(null as any));
    this._el_7 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'\n                ',(null as any));
    this._el_9 = import4.createRenderElement(this.renderer,this._el_7,'div',new import4.InlineArray2(2,'class','form-inline'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n                  ',(null as any));
    this._el_11 = import4.createRenderElement(this.renderer,this._el_9,'div',new import4.InlineArray2(2,'class','col-md-1 col-sm-1 input-group switch material-switch'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n                        ',(null as any));
    this._el_13 = import4.createRenderElement(this.renderer,this._el_11,'input',new import4.InlineArray8(8,'formControlName','active','id','act','name','act','type','checkbox'),(null as any));
    this._CheckboxControlValueAccessor_13_3 = new import28.Wrapper_CheckboxControlValueAccessor(this.renderer,new import33.ElementRef(this._el_13));
    this._NG_VALUE_ACCESSOR_13_4 = [this._CheckboxControlValueAccessor_13_3.context];
    this._FormControlName_13_5 = new import29.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_13_4);
    this._NgControl_13_6 = this._FormControlName_13_5.context;
    this._NgControlStatus_13_7 = new import27.Wrapper_NgControlStatus(this._NgControl_13_6);
    this._text_14 = this.renderer.createText(this._el_11,'\n                        ',(null as any));
    this._el_15 = import4.createRenderElement(this.renderer,this._el_11,'label',new import4.InlineArray4(4,'class','label-primary','for','act'),(null as any));
    this._text_16 = this.renderer.createText(this._el_11,'\n                  ',(null as any));
    this._text_17 = this.renderer.createText(this._el_9,'\n                  ',(null as any));
    this._el_18 = import4.createRenderElement(this.renderer,this._el_9,'div',new import4.InlineArray2(2,'class','input-group col-lg-3 col-md-4 col-sm-5'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n                    ',(null as any));
    this._el_20 = import4.createRenderElement(this.renderer,this._el_18,'div',new import4.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._el_21 = import4.createRenderElement(this.renderer,this._el_20,'i',new import4.InlineArray2(2,'class','fa fa-external-link'),(null as any));
    this._text_22 = this.renderer.createText(this._el_18,'\n                    ',(null as any));
    this._el_23 = import4.createRenderElement(this.renderer,this._el_18,'input',new import4.InlineArray8(6,'class','form-control','formControlName','url','type','text'),(null as any));
    this._DefaultValueAccessor_23_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer,new import33.ElementRef(this._el_23));
    this._NG_VALUE_ACCESSOR_23_4 = [this._DefaultValueAccessor_23_3.context];
    this._FormControlName_23_5 = new import29.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_23_4);
    this._NgControl_23_6 = this._FormControlName_23_5.context;
    this._NgControlStatus_23_7 = new import27.Wrapper_NgControlStatus(this._NgControl_23_6);
    this._text_24 = this.renderer.createText(this._el_18,'\n                  ',(null as any));
    this._text_25 = this.renderer.createText(this._el_9,'\n                  ',(null as any));
    this._el_26 = import4.createRenderElement(this.renderer,this._el_9,'div',new import4.InlineArray4(4,'class','input-group col-lg-3 col-md-4 col-sm-5','style','max-width: 200px'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'\n                    ',(null as any));
    this._el_28 = import4.createRenderElement(this.renderer,this._el_26,'div',new import4.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._el_29 = import4.createRenderElement(this.renderer,this._el_28,'i',new import4.InlineArray2(2,'class','fa fa-calendar'),(null as any));
    this._text_30 = this.renderer.createText(this._el_26,'\n                    ',(null as any));
    this._text_31 = this.renderer.createText(this._el_26,'\n                    ',(null as any));
    this._el_32 = import4.createRenderElement(this.renderer,this._el_26,'input',new import4.InlineArray8(8,'class','form-control','formControlName','date','readonly','','type','text'),(null as any));
    this._DefaultValueAccessor_32_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer,new import33.ElementRef(this._el_32));
    this._NG_VALUE_ACCESSOR_32_4 = [this._DefaultValueAccessor_32_3.context];
    this._FormControlName_32_5 = new import29.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_32_4);
    this._NgControl_32_6 = this._FormControlName_32_5.context;
    this._NgControlStatus_32_7 = new import27.Wrapper_NgControlStatus(this._NgControl_32_6);
    this._text_33 = this.renderer.createText(this._el_26,'\n                  ',(null as any));
    this._text_34 = this.renderer.createText(this._el_9,'\n                  ',(null as any));
    this._el_35 = import4.createRenderElement(this.renderer,this._el_9,'div',new import4.InlineArray2(2,'class','input-group col-lg-3 col-md-4 col-sm-5'),(null as any));
    this._text_36 = this.renderer.createText(this._el_35,'\n                    ',(null as any));
    this._el_37 = import4.createRenderElement(this.renderer,this._el_35,'div',new import4.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._el_38 = import4.createRenderElement(this.renderer,this._el_37,'i',new import4.InlineArray2(2,'class','fa fa-id-card-o'),(null as any));
    this._text_39 = this.renderer.createText(this._el_35,'\n                    ',(null as any));
    this._el_40 = import4.createRenderElement(this.renderer,this._el_35,'input',new import4.InlineArray8(8,'class','form-control','formControlName','_id','readonly','','type','text'),(null as any));
    this._DefaultValueAccessor_40_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer,new import33.ElementRef(this._el_40));
    this._NG_VALUE_ACCESSOR_40_4 = [this._DefaultValueAccessor_40_3.context];
    this._FormControlName_40_5 = new import29.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_40_4);
    this._NgControl_40_6 = this._FormControlName_40_5.context;
    this._NgControlStatus_40_7 = new import27.Wrapper_NgControlStatus(this._NgControl_40_6);
    this._text_41 = this.renderer.createText(this._el_35,'\n                  ',(null as any));
    this._text_42 = this.renderer.createText(this._el_9,'\n                ',(null as any));
    this._text_43 = this.renderer.createText(this._el_7,'\n              ',(null as any));
    this._text_44 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._el_45 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_46 = this.renderer.createText(this._el_45,'Titre',(null as any));
    this._text_47 = this.renderer.createText(this._el_2,'\n              ',(null as any));
    this._el_48 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_49 = this.renderer.createText(this._el_48,'\n                ',(null as any));
    this._el_50 = import4.createRenderElement(this.renderer,this._el_48,'div',new import4.InlineArray2(2,'formGroupName','title'),(null as any));
    this._FormGroupName_50_3 = new import31.Wrapper_FormGroupName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_50_4 = this._FormGroupName_50_3.context;
    this._NgControlStatusGroup_50_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_50_4);
    this._text_51 = this.renderer.createText(this._el_50,'\n                  ',(null as any));
    this._anchor_52 = this.renderer.createTemplateAnchor(this._el_50,(null as any));
    this._appEl_52 = new import3.AppElement(52,50,this,this._anchor_52);
    this._TemplateRef_52_5 = new import22.TemplateRef_(this._appEl_52,viewFactory_ContentPageEditComponent5);
    this._NgFor_52_6 = new import32.Wrapper_NgFor(this._appEl_52.vcRef,this._TemplateRef_52_5,this.parent.parentInjector.get(import34.IterableDiffers),this.parent.ref);
    this._text_53 = this.renderer.createText(this._el_50,'\n                ',(null as any));
    this._text_54 = this.renderer.createText(this._el_48,'\n              ',(null as any));
    this._text_55 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._text_56 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._el_57 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_58 = this.renderer.createText(this._el_57,'Contenu',(null as any));
    this._text_59 = this.renderer.createText(this._el_2,'\n              ',(null as any));
    this._el_60 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_61 = this.renderer.createText(this._el_60,'\n                ',(null as any));
    this._el_62 = import4.createRenderElement(this.renderer,this._el_60,'div',new import4.InlineArray2(2,'formGroupName','content'),(null as any));
    this._FormGroupName_62_3 = new import31.Wrapper_FormGroupName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_62_4 = this._FormGroupName_62_3.context;
    this._NgControlStatusGroup_62_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_62_4);
    this._text_63 = this.renderer.createText(this._el_62,'\n                  ',(null as any));
    this._anchor_64 = this.renderer.createTemplateAnchor(this._el_62,(null as any));
    this._appEl_64 = new import3.AppElement(64,62,this,this._anchor_64);
    this._TemplateRef_64_5 = new import22.TemplateRef_(this._appEl_64,viewFactory_ContentPageEditComponent6);
    this._NgFor_64_6 = new import32.Wrapper_NgFor(this._appEl_64.vcRef,this._TemplateRef_64_5,this.parent.parentInjector.get(import34.IterableDiffers),this.parent.ref);
    this._text_65 = this.renderer.createText(this._el_62,'\n                ',(null as any));
    this._text_66 = this.renderer.createText(this._el_60,'\n              ',(null as any));
    this._text_67 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._el_68 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_69 = this.renderer.createText(this._el_68,'Résumé',(null as any));
    this._text_70 = this.renderer.createText(this._el_2,'\n              ',(null as any));
    this._el_71 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_72 = this.renderer.createText(this._el_71,'\n                ',(null as any));
    this._el_73 = import4.createRenderElement(this.renderer,this._el_71,'div',new import4.InlineArray2(2,'formGroupName','content'),(null as any));
    this._FormGroupName_73_3 = new import31.Wrapper_FormGroupName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_73_4 = this._FormGroupName_73_3.context;
    this._NgControlStatusGroup_73_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_73_4);
    this._text_74 = this.renderer.createText(this._el_73,'\n                  ',(null as any));
    this._anchor_75 = this.renderer.createTemplateAnchor(this._el_73,(null as any));
    this._appEl_75 = new import3.AppElement(75,73,this,this._anchor_75);
    this._TemplateRef_75_5 = new import22.TemplateRef_(this._appEl_75,viewFactory_ContentPageEditComponent7);
    this._NgFor_75_6 = new import32.Wrapper_NgFor(this._appEl_75.vcRef,this._TemplateRef_75_5,this.parent.parentInjector.get(import34.IterableDiffers),this.parent.ref);
    this._text_76 = this.renderer.createText(this._el_73,'\n                ',(null as any));
    this._text_77 = this.renderer.createText(this._el_71,'\n              ',(null as any));
    this._text_78 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._el_79 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_80 = this.renderer.createText(this._el_79,'Tags',(null as any));
    this._text_81 = this.renderer.createText(this._el_2,'\n              ',(null as any));
    this._el_82 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray4(4,'class','panel-body','formArrayName','tags'),(null as any));
    this._FormArrayName_82_3 = new import31.Wrapper_FormArrayName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_82_4 = this._FormArrayName_82_3.context;
    this._NgControlStatusGroup_82_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_82_4);
    this._text_83 = this.renderer.createText(this._el_82,'\n                ',(null as any));
    this._el_84 = import4.createRenderElement(this.renderer,this._el_82,'div',new import4.InlineArray2(2,'class','form-inline'),(null as any));
    this._text_85 = this.renderer.createText(this._el_84,'\n                  ',(null as any));
    this._anchor_86 = this.renderer.createTemplateAnchor(this._el_84,(null as any));
    this._appEl_86 = new import3.AppElement(86,84,this,this._anchor_86);
    this._TemplateRef_86_5 = new import22.TemplateRef_(this._appEl_86,viewFactory_ContentPageEditComponent8);
    this._NgFor_86_6 = new import32.Wrapper_NgFor(this._appEl_86.vcRef,this._TemplateRef_86_5,this.parent.parentInjector.get(import34.IterableDiffers),this.parent.ref);
    this._text_87 = this.renderer.createText(this._el_84,'\n                  ',(null as any));
    this._el_88 = import4.createRenderElement(this.renderer,this._el_84,'a',new import4.InlineArray2(2,'class','glyphicon glyphicon-plus clickLink'),(null as any));
    this._text_89 = this.renderer.createText(this._el_88,' ',(null as any));
    this._text_90 = this.renderer.createText(this._el_84,'\n                ',(null as any));
    this._text_91 = this.renderer.createText(this._el_82,'\n              ',(null as any));
    this._text_92 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._el_93 = import4.createRenderElement(this.renderer,this._el_2,'button',new import4.InlineArray4(4,'class','btn btn-info pull-right','type','submit'),(null as any));
    this._text_94 = this.renderer.createText(this._el_93,'\n        Sauvegarder\n      ',(null as any));
    this._text_95 = this.renderer.createText(this._el_2,'\n\n            ',(null as any));
    this._text_96 = this.renderer.createText(this._el_0,'\n\n          ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'ngSubmit',this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_0,'submit',this.eventHandler(this._handle_submit_0_1.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_0,'reset',this.eventHandler(this._handle_reset_0_2.bind(this)));
    const subscription_0:any = this._FormGroupDirective_0_3.context.ngSubmit.subscribe(this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
    var disposable_3:Function = this.renderer.listen(this._el_13,'change',this.eventHandler(this._handle_change_13_0.bind(this)));
    var disposable_4:Function = this.renderer.listen(this._el_13,'blur',this.eventHandler(this._handle_blur_13_1.bind(this)));
    var disposable_5:Function = this.renderer.listen(this._el_23,'input',this.eventHandler(this._handle_input_23_0.bind(this)));
    var disposable_6:Function = this.renderer.listen(this._el_23,'blur',this.eventHandler(this._handle_blur_23_1.bind(this)));
    var disposable_7:Function = this.renderer.listen(this._el_32,'input',this.eventHandler(this._handle_input_32_0.bind(this)));
    var disposable_8:Function = this.renderer.listen(this._el_32,'blur',this.eventHandler(this._handle_blur_32_1.bind(this)));
    var disposable_9:Function = this.renderer.listen(this._el_40,'input',this.eventHandler(this._handle_input_40_0.bind(this)));
    var disposable_10:Function = this.renderer.listen(this._el_40,'blur',this.eventHandler(this._handle_blur_40_1.bind(this)));
    var disposable_11:Function = this.renderer.listen(this._el_88,'click',this.eventHandler(this._handle_click_88_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._el_29,
      this._text_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._text_34,
      this._el_35,
      this._text_36,
      this._el_37,
      this._el_38,
      this._text_39,
      this._el_40,
      this._text_41,
      this._text_42,
      this._text_43,
      this._text_44,
      this._el_45,
      this._text_46,
      this._text_47,
      this._el_48,
      this._text_49,
      this._el_50,
      this._text_51,
      this._anchor_52,
      this._text_53,
      this._text_54,
      this._text_55,
      this._text_56,
      this._el_57,
      this._text_58,
      this._text_59,
      this._el_60,
      this._text_61,
      this._el_62,
      this._text_63,
      this._anchor_64,
      this._text_65,
      this._text_66,
      this._text_67,
      this._el_68,
      this._text_69,
      this._text_70,
      this._el_71,
      this._text_72,
      this._el_73,
      this._text_74,
      this._anchor_75,
      this._text_76,
      this._text_77,
      this._text_78,
      this._el_79,
      this._text_80,
      this._text_81,
      this._el_82,
      this._text_83,
      this._el_84,
      this._text_85,
      this._anchor_86,
      this._text_87,
      this._el_88,
      this._text_89,
      this._text_90,
      this._text_91,
      this._text_92,
      this._el_93,
      this._text_94,
      this._text_95,
      this._text_96
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6,
      disposable_7,
      disposable_8,
      disposable_9,
      disposable_10,
      disposable_11
    ]
    ,[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import35.CheckboxControlValueAccessor) && (13 === requestNodeIndex))) { return this._CheckboxControlValueAccessor_13_3.context; }
    if (((token === import36.NG_VALUE_ACCESSOR) && (13 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_13_4; }
    if (((token === import37.FormControlName) && (13 === requestNodeIndex))) { return this._FormControlName_13_5.context; }
    if (((token === import38.NgControl) && (13 === requestNodeIndex))) { return this._NgControl_13_6; }
    if (((token === import39.NgControlStatus) && (13 === requestNodeIndex))) { return this._NgControlStatus_13_7.context; }
    if (((token === import40.DefaultValueAccessor) && (23 === requestNodeIndex))) { return this._DefaultValueAccessor_23_3.context; }
    if (((token === import36.NG_VALUE_ACCESSOR) && (23 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_23_4; }
    if (((token === import37.FormControlName) && (23 === requestNodeIndex))) { return this._FormControlName_23_5.context; }
    if (((token === import38.NgControl) && (23 === requestNodeIndex))) { return this._NgControl_23_6; }
    if (((token === import39.NgControlStatus) && (23 === requestNodeIndex))) { return this._NgControlStatus_23_7.context; }
    if (((token === import40.DefaultValueAccessor) && (32 === requestNodeIndex))) { return this._DefaultValueAccessor_32_3.context; }
    if (((token === import36.NG_VALUE_ACCESSOR) && (32 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_32_4; }
    if (((token === import37.FormControlName) && (32 === requestNodeIndex))) { return this._FormControlName_32_5.context; }
    if (((token === import38.NgControl) && (32 === requestNodeIndex))) { return this._NgControl_32_6; }
    if (((token === import39.NgControlStatus) && (32 === requestNodeIndex))) { return this._NgControlStatus_32_7.context; }
    if (((token === import40.DefaultValueAccessor) && (40 === requestNodeIndex))) { return this._DefaultValueAccessor_40_3.context; }
    if (((token === import36.NG_VALUE_ACCESSOR) && (40 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_40_4; }
    if (((token === import37.FormControlName) && (40 === requestNodeIndex))) { return this._FormControlName_40_5.context; }
    if (((token === import38.NgControl) && (40 === requestNodeIndex))) { return this._NgControl_40_6; }
    if (((token === import39.NgControlStatus) && (40 === requestNodeIndex))) { return this._NgControlStatus_40_7.context; }
    if (((token === import22.TemplateRef) && (52 === requestNodeIndex))) { return this._TemplateRef_52_5; }
    if (((token === import41.NgFor) && (52 === requestNodeIndex))) { return this._NgFor_52_6.context; }
    if (((token === import42.FormGroupName) && ((50 <= requestNodeIndex) && (requestNodeIndex <= 53)))) { return this._FormGroupName_50_3.context; }
    if (((token === import43.ControlContainer) && ((50 <= requestNodeIndex) && (requestNodeIndex <= 53)))) { return this._ControlContainer_50_4; }
    if (((token === import39.NgControlStatusGroup) && ((50 <= requestNodeIndex) && (requestNodeIndex <= 53)))) { return this._NgControlStatusGroup_50_5.context; }
    if (((token === import22.TemplateRef) && (64 === requestNodeIndex))) { return this._TemplateRef_64_5; }
    if (((token === import41.NgFor) && (64 === requestNodeIndex))) { return this._NgFor_64_6.context; }
    if (((token === import42.FormGroupName) && ((62 <= requestNodeIndex) && (requestNodeIndex <= 65)))) { return this._FormGroupName_62_3.context; }
    if (((token === import43.ControlContainer) && ((62 <= requestNodeIndex) && (requestNodeIndex <= 65)))) { return this._ControlContainer_62_4; }
    if (((token === import39.NgControlStatusGroup) && ((62 <= requestNodeIndex) && (requestNodeIndex <= 65)))) { return this._NgControlStatusGroup_62_5.context; }
    if (((token === import22.TemplateRef) && (75 === requestNodeIndex))) { return this._TemplateRef_75_5; }
    if (((token === import41.NgFor) && (75 === requestNodeIndex))) { return this._NgFor_75_6.context; }
    if (((token === import42.FormGroupName) && ((73 <= requestNodeIndex) && (requestNodeIndex <= 76)))) { return this._FormGroupName_73_3.context; }
    if (((token === import43.ControlContainer) && ((73 <= requestNodeIndex) && (requestNodeIndex <= 76)))) { return this._ControlContainer_73_4; }
    if (((token === import39.NgControlStatusGroup) && ((73 <= requestNodeIndex) && (requestNodeIndex <= 76)))) { return this._NgControlStatusGroup_73_5.context; }
    if (((token === import22.TemplateRef) && (86 === requestNodeIndex))) { return this._TemplateRef_86_5; }
    if (((token === import41.NgFor) && (86 === requestNodeIndex))) { return this._NgFor_86_6.context; }
    if (((token === import42.FormArrayName) && ((82 <= requestNodeIndex) && (requestNodeIndex <= 91)))) { return this._FormArrayName_82_3.context; }
    if (((token === import43.ControlContainer) && ((82 <= requestNodeIndex) && (requestNodeIndex <= 91)))) { return this._ControlContainer_82_4; }
    if (((token === import39.NgControlStatusGroup) && ((82 <= requestNodeIndex) && (requestNodeIndex <= 91)))) { return this._NgControlStatusGroup_82_5.context; }
    if (((token === import44.FormGroupDirective) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 96)))) { return this._FormGroupDirective_0_3.context; }
    if (((token === import43.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 96)))) { return this._ControlContainer_0_4; }
    if (((token === import39.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 96)))) { return this._NgControlStatusGroup_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.parent.context.pageForm;
    this._FormGroupDirective_0_3.check_form(currVal_0_0_0,throwOnChange,false);
    this._FormGroupDirective_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this._CheckboxControlValueAccessor_13_3.detectChangesInInputProps(this,this._el_13,throwOnChange);
    const currVal_13_1_0:any = 'active';
    this._FormControlName_13_5.check_name(currVal_13_1_0,throwOnChange,false);
    this._FormControlName_13_5.detectChangesInInputProps(this,this._el_13,throwOnChange);
    this._NgControlStatus_13_7.detectChangesInInputProps(this,this._el_13,throwOnChange);
    this._DefaultValueAccessor_23_3.detectChangesInInputProps(this,this._el_23,throwOnChange);
    const currVal_23_1_0:any = 'url';
    this._FormControlName_23_5.check_name(currVal_23_1_0,throwOnChange,false);
    this._FormControlName_23_5.detectChangesInInputProps(this,this._el_23,throwOnChange);
    this._NgControlStatus_23_7.detectChangesInInputProps(this,this._el_23,throwOnChange);
    this._DefaultValueAccessor_32_3.detectChangesInInputProps(this,this._el_32,throwOnChange);
    const currVal_32_1_0:any = 'date';
    this._FormControlName_32_5.check_name(currVal_32_1_0,throwOnChange,false);
    this._FormControlName_32_5.detectChangesInInputProps(this,this._el_32,throwOnChange);
    this._NgControlStatus_32_7.detectChangesInInputProps(this,this._el_32,throwOnChange);
    this._DefaultValueAccessor_40_3.detectChangesInInputProps(this,this._el_40,throwOnChange);
    const currVal_40_1_0:any = '_id';
    this._FormControlName_40_5.check_name(currVal_40_1_0,throwOnChange,false);
    this._FormControlName_40_5.detectChangesInInputProps(this,this._el_40,throwOnChange);
    this._NgControlStatus_40_7.detectChangesInInputProps(this,this._el_40,throwOnChange);
    const currVal_50_0_0:any = 'title';
    this._FormGroupName_50_3.check_name(currVal_50_0_0,throwOnChange,false);
    this._FormGroupName_50_3.detectChangesInInputProps(this,this._el_50,throwOnChange);
    this._NgControlStatusGroup_50_5.detectChangesInInputProps(this,this._el_50,throwOnChange);
    const currVal_52_0_0:any = ((this.parent.context.config.data == (null as any))? (null as any): this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
    this._NgFor_52_6.check_ngForOf(currVal_52_0_0,throwOnChange,false);
    this._NgFor_52_6.detectChangesInInputProps(this,this._anchor_52,throwOnChange);
    const currVal_62_0_0:any = 'content';
    this._FormGroupName_62_3.check_name(currVal_62_0_0,throwOnChange,false);
    this._FormGroupName_62_3.detectChangesInInputProps(this,this._el_62,throwOnChange);
    this._NgControlStatusGroup_62_5.detectChangesInInputProps(this,this._el_62,throwOnChange);
    const currVal_64_0_0:any = ((this.parent.context.config.data == (null as any))? (null as any): this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
    this._NgFor_64_6.check_ngForOf(currVal_64_0_0,throwOnChange,false);
    this._NgFor_64_6.detectChangesInInputProps(this,this._anchor_64,throwOnChange);
    const currVal_73_0_0:any = 'content';
    this._FormGroupName_73_3.check_name(currVal_73_0_0,throwOnChange,false);
    this._FormGroupName_73_3.detectChangesInInputProps(this,this._el_73,throwOnChange);
    this._NgControlStatusGroup_73_5.detectChangesInInputProps(this,this._el_73,throwOnChange);
    const currVal_75_0_0:any = ((this.parent.context.config.data == (null as any))? (null as any): this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
    this._NgFor_75_6.check_ngForOf(currVal_75_0_0,throwOnChange,false);
    this._NgFor_75_6.detectChangesInInputProps(this,this._anchor_75,throwOnChange);
    const currVal_82_0_0:any = 'tags';
    this._FormArrayName_82_3.check_name(currVal_82_0_0,throwOnChange,false);
    this._FormArrayName_82_3.detectChangesInInputProps(this,this._el_82,throwOnChange);
    this._NgControlStatusGroup_82_5.detectChangesInInputProps(this,this._el_82,throwOnChange);
    const currVal_86_0_0:any = this.parent.context.pageForm.controls.tags.controls;
    this._NgFor_86_6.check_ngForOf(currVal_86_0_0,throwOnChange,false);
    this._NgFor_86_6.detectChangesInInputProps(this,this._anchor_86,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._FormGroupDirective_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._CheckboxControlValueAccessor_13_3.detectChangesInHostProps(this,this._el_13,throwOnChange);
    this._FormControlName_13_5.detectChangesInHostProps(this,this._el_13,throwOnChange);
    this._NgControlStatus_13_7.detectChangesInHostProps(this,this._el_13,throwOnChange);
    this._DefaultValueAccessor_23_3.detectChangesInHostProps(this,this._el_23,throwOnChange);
    this._FormControlName_23_5.detectChangesInHostProps(this,this._el_23,throwOnChange);
    this._NgControlStatus_23_7.detectChangesInHostProps(this,this._el_23,throwOnChange);
    this._DefaultValueAccessor_32_3.detectChangesInHostProps(this,this._el_32,throwOnChange);
    this._FormControlName_32_5.detectChangesInHostProps(this,this._el_32,throwOnChange);
    this._NgControlStatus_32_7.detectChangesInHostProps(this,this._el_32,throwOnChange);
    this._DefaultValueAccessor_40_3.detectChangesInHostProps(this,this._el_40,throwOnChange);
    this._FormControlName_40_5.detectChangesInHostProps(this,this._el_40,throwOnChange);
    this._NgControlStatus_40_7.detectChangesInHostProps(this,this._el_40,throwOnChange);
    this._FormGroupName_50_3.detectChangesInHostProps(this,this._el_50,throwOnChange);
    this._NgControlStatusGroup_50_5.detectChangesInHostProps(this,this._el_50,throwOnChange);
    this._FormGroupName_62_3.detectChangesInHostProps(this,this._el_62,throwOnChange);
    this._NgControlStatusGroup_62_5.detectChangesInHostProps(this,this._el_62,throwOnChange);
    this._FormGroupName_73_3.detectChangesInHostProps(this,this._el_73,throwOnChange);
    this._NgControlStatusGroup_73_5.detectChangesInHostProps(this,this._el_73,throwOnChange);
    this._FormArrayName_82_3.detectChangesInHostProps(this,this._el_82,throwOnChange);
    this._NgControlStatusGroup_82_5.detectChangesInHostProps(this,this._el_82,throwOnChange);
    const currVal_144:boolean = !this.parent.context.pageForm.valid;
    if (import4.checkBinding(throwOnChange,this._expr_144,currVal_144)) {
      this.renderer.setElementProperty(this._el_93,'disabled',currVal_144);
      this._expr_144 = currVal_144;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_13_5.context.ngOnDestroy();
    this._FormControlName_23_5.context.ngOnDestroy();
    this._FormControlName_32_5.context.ngOnDestroy();
    this._FormControlName_40_5.context.ngOnDestroy();
    this._FormArrayName_82_3.context.ngOnDestroy();
  }
  private _handle_ngSubmit_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.context.onSubmit()) !== false);
    return (true && pd_0_0);
  }
  private _handle_submit_0_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this._FormGroupDirective_0_3.context.onSubmit($event)) !== false);
    return (true && pd_0_0);
  }
  private _handle_reset_0_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this._FormGroupDirective_0_3.context.onReset()) !== false);
    return (true && pd_0_0);
  }
  private _handle_change_13_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_13_0:any = ((<any>this._CheckboxControlValueAccessor_13_3.context.onChange($event.target.checked)) !== false);
    return (true && pd_13_0);
  }
  private _handle_blur_13_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_13_0:any = ((<any>this._CheckboxControlValueAccessor_13_3.context.onTouched()) !== false);
    return (true && pd_13_0);
  }
  private _handle_input_23_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_23_0:any = ((<any>this._DefaultValueAccessor_23_3.context.onChange($event.target.value)) !== false);
    return (true && pd_23_0);
  }
  private _handle_blur_23_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_23_0:any = ((<any>this._DefaultValueAccessor_23_3.context.onTouched()) !== false);
    return (true && pd_23_0);
  }
  private _handle_input_32_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_32_0:any = ((<any>this._DefaultValueAccessor_32_3.context.onChange($event.target.value)) !== false);
    return (true && pd_32_0);
  }
  private _handle_blur_32_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_32_0:any = ((<any>this._DefaultValueAccessor_32_3.context.onTouched()) !== false);
    return (true && pd_32_0);
  }
  private _handle_input_40_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_40_0:any = ((<any>this._DefaultValueAccessor_40_3.context.onChange($event.target.value)) !== false);
    return (true && pd_40_0);
  }
  private _handle_blur_40_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_40_0:any = ((<any>this._DefaultValueAccessor_40_3.context.onTouched()) !== false);
    return (true && pd_40_0);
  }
  private _handle_click_88_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_88_0:any = ((<any>this.parent.context.onAddTag()) !== false);
    return (true && pd_88_0);
  }
}
function viewFactory_ContentPageEditComponent4(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentPageEditComponent4(viewUtils,parentInjector,declarationEl);
}
class _View_ContentPageEditComponent5 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _DefaultValueAccessor_5_3:import30.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_5_4:any[];
  _FormControlName_5_5:import29.Wrapper_FormControlName;
  _NgControl_5_6:any;
  _NgControlStatus_5_7:import27.Wrapper_NgControlStatus;
  _text_6:any;
  /*private*/ _expr_12:any;
  _pipe_uppercase_1_0:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPageEditComponent5,renderType_ContentPageEditComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_12 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','form-group input-group'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_5 = import4.createRenderElement(this.renderer,this._el_0,'input',new import4.InlineArray4(4,'class','form-control','type','text'),(null as any));
    this._DefaultValueAccessor_5_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer,new import33.ElementRef(this._el_5));
    this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
    this._FormControlName_5_5 = new import29.Wrapper_FormControlName((<_View_ContentPageEditComponent4>this.parent)._ControlContainer_50_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_5_4);
    this._NgControl_5_6 = this._FormControlName_5_5.context;
    this._NgControlStatus_5_7 = new import27.Wrapper_NgControlStatus(this._NgControl_5_6);
    this._text_6 = this.renderer.createText(this._el_0,'\n                  ',(null as any));
    this._pipe_uppercase_1_0 = import4.pureProxy1((<_View_ContentPageEditComponent0>this.parent.parent)._pipe_uppercase_1.transform.bind((<_View_ContentPageEditComponent0>this.parent.parent)._pipe_uppercase_1));
    var disposable_0:Function = this.renderer.listen(this._el_5,'input',this.eventHandler(this._handle_input_5_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_5,'blur',this.eventHandler(this._handle_blur_5_1.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6
    ]
    ,[
      disposable_0,
      disposable_1
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import40.DefaultValueAccessor) && (5 === requestNodeIndex))) { return this._DefaultValueAccessor_5_3.context; }
    if (((token === import36.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_5_4; }
    if (((token === import37.FormControlName) && (5 === requestNodeIndex))) { return this._FormControlName_5_5.context; }
    if (((token === import38.NgControl) && (5 === requestNodeIndex))) { return this._NgControl_5_6; }
    if (((token === import39.NgControlStatus) && (5 === requestNodeIndex))) { return this._NgControlStatus_5_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this._DefaultValueAccessor_5_3.detectChangesInInputProps(this,this._el_5,throwOnChange);
    const currVal_5_1_0:any = this.context.$implicit;
    this._FormControlName_5_5.check_name(currVal_5_1_0,throwOnChange,false);
    this._FormControlName_5_5.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_12:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_uppercase_1_0,(<_View_ContentPageEditComponent0>this.parent.parent)._pipe_uppercase_1.transform)(this.context.$implicit)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_12,currVal_12))) {
      this.renderer.setText(this._text_3,currVal_12);
      this._expr_12 = currVal_12;
    }
    this._DefaultValueAccessor_5_3.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._FormControlName_5_5.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_5_5.context.ngOnDestroy();
  }
  private _handle_input_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onChange($event.target.value)) !== false);
    return (true && pd_5_0);
  }
  private _handle_blur_5_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onTouched()) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_ContentPageEditComponent5(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentPageEditComponent5(viewUtils,parentInjector,declarationEl);
}
class _View_ContentPageEditComponent6 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  /*private*/ _appEl_5:import3.AppElement;
  _HtmlEditorComponent_5_4:import45.Wrapper_HtmlEditorComponent;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_10:any;
  _pipe_uppercase_1_1:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPageEditComponent6,renderType_ContentPageEditComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_10 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','form-group'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'small',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_5 = import4.createRenderElement(this.renderer,this._el_0,'html-editor',new import4.InlineArray2(2,'height','50'),(null as any));
    this._appEl_5 = new import3.AppElement(5,0,this,this._el_5);
    var compView_5:any = import45.viewFactory_HtmlEditorComponent0(this.viewUtils,this.injector(5),this._appEl_5);
    this._HtmlEditorComponent_5_4 = new import45.Wrapper_HtmlEditorComponent();
    this._appEl_5.initComponent(this._HtmlEditorComponent_5_4.context,([] as any[]),compView_5);
    this._text_6 = this.renderer.createText((null as any),'\n                    ',(null as any));
    compView_5.create(this._HtmlEditorComponent_5_4.context,([] as any[]),(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                  ',(null as any));
    this._pipe_uppercase_1_1 = import4.pureProxy1((<_View_ContentPageEditComponent0>this.parent.parent)._pipe_uppercase_1.transform.bind((<_View_ContentPageEditComponent0>this.parent.parent)._pipe_uppercase_1));
    var disposable_0:Function = this.renderer.listen(this._el_5,'onEditorKeyup',this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
    const subscription_0:any = this._HtmlEditorComponent_5_4.context.onEditorKeyup.subscribe(this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ,[disposable_0],[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import46.HtmlEditorComponent) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._HtmlEditorComponent_5_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    const currVal_5_0_0:any = ('editor-content-' + this.context.$implicit);
    this._HtmlEditorComponent_5_4.check_elementId(currVal_5_0_0,throwOnChange,false);
    const currVal_5_0_1:any = (this.parent.parent.context.content? this.parent.parent.context.content.content[this.context.$implicit]: '');
    this._HtmlEditorComponent_5_4.check_initText(currVal_5_0_1,throwOnChange,false);
    const currVal_5_0_2:any = '50';
    this._HtmlEditorComponent_5_4.check_height(currVal_5_0_2,throwOnChange,false);
    this._HtmlEditorComponent_5_4.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_10:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_uppercase_1_1,(<_View_ContentPageEditComponent0>this.parent.parent)._pipe_uppercase_1.transform)(this.context.$implicit)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_10,currVal_10))) {
      this.renderer.setText(this._text_3,currVal_10);
      this._expr_10 = currVal_10;
    }
    this._HtmlEditorComponent_5_4.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._HtmlEditorComponent_5_4.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this._HtmlEditorComponent_5_4.context.ngOnDestroy();
  }
  private _handle_onEditorKeyup_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this.parent.parent.context.keyupEditorHandlerFunction([
      'content',
      this.context.$implicit
    ]
    ,$event)) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_ContentPageEditComponent6(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentPageEditComponent6(viewUtils,parentInjector,declarationEl);
}
class _View_ContentPageEditComponent7 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  /*private*/ _appEl_5:import3.AppElement;
  _HtmlEditorComponent_5_4:import45.Wrapper_HtmlEditorComponent;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_10:any;
  _pipe_uppercase_1_2:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPageEditComponent7,renderType_ContentPageEditComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_10 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','form-group'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'small',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_5 = import4.createRenderElement(this.renderer,this._el_0,'html-editor',new import4.InlineArray2(2,'height','10'),(null as any));
    this._appEl_5 = new import3.AppElement(5,0,this,this._el_5);
    var compView_5:any = import45.viewFactory_HtmlEditorComponent0(this.viewUtils,this.injector(5),this._appEl_5);
    this._HtmlEditorComponent_5_4 = new import45.Wrapper_HtmlEditorComponent();
    this._appEl_5.initComponent(this._HtmlEditorComponent_5_4.context,([] as any[]),compView_5);
    this._text_6 = this.renderer.createText((null as any),'\n                    ',(null as any));
    compView_5.create(this._HtmlEditorComponent_5_4.context,([] as any[]),(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                  ',(null as any));
    this._pipe_uppercase_1_2 = import4.pureProxy1((<_View_ContentPageEditComponent0>this.parent.parent)._pipe_uppercase_1.transform.bind((<_View_ContentPageEditComponent0>this.parent.parent)._pipe_uppercase_1));
    var disposable_0:Function = this.renderer.listen(this._el_5,'onEditorKeyup',this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
    const subscription_0:any = this._HtmlEditorComponent_5_4.context.onEditorKeyup.subscribe(this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ,[disposable_0],[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import46.HtmlEditorComponent) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._HtmlEditorComponent_5_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    const currVal_5_0_0:any = ('editor-summary-' + this.context.$implicit);
    this._HtmlEditorComponent_5_4.check_elementId(currVal_5_0_0,throwOnChange,false);
    const currVal_5_0_1:any = (this.parent.parent.context.content? this.parent.parent.context.content.summary[this.context.$implicit]: '');
    this._HtmlEditorComponent_5_4.check_initText(currVal_5_0_1,throwOnChange,false);
    const currVal_5_0_2:any = '10';
    this._HtmlEditorComponent_5_4.check_height(currVal_5_0_2,throwOnChange,false);
    this._HtmlEditorComponent_5_4.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_10:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_uppercase_1_2,(<_View_ContentPageEditComponent0>this.parent.parent)._pipe_uppercase_1.transform)(this.context.$implicit)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_10,currVal_10))) {
      this.renderer.setText(this._text_3,currVal_10);
      this._expr_10 = currVal_10;
    }
    this._HtmlEditorComponent_5_4.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._HtmlEditorComponent_5_4.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this._HtmlEditorComponent_5_4.context.ngOnDestroy();
  }
  private _handle_onEditorKeyup_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this.parent.parent.context.keyupEditorHandlerFunction([
      'summary',
      this.context.$implicit
    ]
    ,$event)) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_ContentPageEditComponent7(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentPageEditComponent7(viewUtils,parentInjector,declarationEl);
}
class _View_ContentPageEditComponent8 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _DefaultValueAccessor_2_3:import30.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_2_4:any[];
  _FormControlName_2_5:import29.Wrapper_FormControlName;
  _NgControl_2_6:any;
  _NgControlStatus_2_7:import27.Wrapper_NgControlStatus;
  _text_3:any;
  _el_4:any;
  _el_5:any;
  _text_6:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPageEditComponent8,renderType_ContentPageEditComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray4(4,'class','input-group col-lg-3 col-md-4 col-sm-5','style','padding: 0px 3px 3px 0px; max-width: 200px'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'input',new import4.InlineArray4(4,'class','form-control','type','text'),(null as any));
    this._DefaultValueAccessor_2_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer,new import33.ElementRef(this._el_2));
    this._NG_VALUE_ACCESSOR_2_4 = [this._DefaultValueAccessor_2_3.context];
    this._FormControlName_2_5 = new import29.Wrapper_FormControlName((<_View_ContentPageEditComponent4>this.parent)._ControlContainer_82_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_2_4);
    this._NgControl_2_6 = this._FormControlName_2_5.context;
    this._NgControlStatus_2_7 = new import27.Wrapper_NgControlStatus(this._NgControl_2_6);
    this._text_3 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._el_5 = import4.createRenderElement(this.renderer,this._el_4,'a',new import4.InlineArray2(2,'class','glyphicon glyphicon-remove clickLink'),(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n                  ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_2,'input',this.eventHandler(this._handle_input_2_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_2,'blur',this.eventHandler(this._handle_blur_2_1.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_5,'click',this.eventHandler(this._handle_click_5_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._el_5,
      this._text_6
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import40.DefaultValueAccessor) && (2 === requestNodeIndex))) { return this._DefaultValueAccessor_2_3.context; }
    if (((token === import36.NG_VALUE_ACCESSOR) && (2 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_2_4; }
    if (((token === import37.FormControlName) && (2 === requestNodeIndex))) { return this._FormControlName_2_5.context; }
    if (((token === import38.NgControl) && (2 === requestNodeIndex))) { return this._NgControl_2_6; }
    if (((token === import39.NgControlStatus) && (2 === requestNodeIndex))) { return this._NgControlStatus_2_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._DefaultValueAccessor_2_3.detectChangesInInputProps(this,this._el_2,throwOnChange);
    const currVal_2_1_0:any = import4.interpolate(1,'',this.context.index,'');
    this._FormControlName_2_5.check_name(currVal_2_1_0,throwOnChange,false);
    this._FormControlName_2_5.detectChangesInInputProps(this,this._el_2,throwOnChange);
    this._NgControlStatus_2_7.detectChangesInInputProps(this,this._el_2,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._DefaultValueAccessor_2_3.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this._FormControlName_2_5.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this._NgControlStatus_2_7.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_2_5.context.ngOnDestroy();
  }
  private _handle_input_2_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this._DefaultValueAccessor_2_3.context.onChange($event.target.value)) !== false);
    return (true && pd_2_0);
  }
  private _handle_blur_2_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this._DefaultValueAccessor_2_3.context.onTouched()) !== false);
    return (true && pd_2_0);
  }
  private _handle_click_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this.parent.parent.context.onRemoveTag(this.context.index)) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_ContentPageEditComponent8(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentPageEditComponent8(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/content-page-edit.component.ngfactory.ts